/*
 * Account DataSet
 */
export var AccountDataAnalysisDataSet;
(function (AccountDataAnalysisDataSet) {
    AccountDataAnalysisDataSet["TOTAL_COUNT"] = "total_count";
    AccountDataAnalysisDataSet["TOTAL_DAYS"] = "total_days";
})(AccountDataAnalysisDataSet || (AccountDataAnalysisDataSet = {}));
/*
 * 搜索入参时间颗粒度
 */
export var GRANULARITY;
(function (GRANULARITY) {
    GRANULARITY["DAY"] = "day";
    GRANULARITY["WEEK"] = "week";
    GRANULARITY["MONTH"] = "month";
})(GRANULARITY || (GRANULARITY = {}));
/*
 * 数据分析类型
 */
export var AccountDataAnalysisKeyType;
(function (AccountDataAnalysisKeyType) {
    AccountDataAnalysisKeyType["EUREKA_USER_LOGIN"] = "eureka_user_login";
    AccountDataAnalysisKeyType["EUREKA_RD_USER_BEHAVIOR"] = "eureka_rd_user_behavior";
    AccountDataAnalysisKeyType["EUREKA_IP_USER_BEHAVIOR"] = "eureka_ip_user_behavior";
    AccountDataAnalysisKeyType["EUREKA_MATERIAL_USER_BEHAVIOR"] = "eureka_material_user_behavior";
    AccountDataAnalysisKeyType["EUREKA_USER_COMPREHENSIVE"] = "eureka_user_comprehensive";
})(AccountDataAnalysisKeyType || (AccountDataAnalysisKeyType = {}));
// reportName下的事件名称
export var AccountDataAnalysisEventKey;
(function (AccountDataAnalysisEventKey) {
    AccountDataAnalysisEventKey["DATE"] = "date";
    AccountDataAnalysisEventKey["LOGIN"] = "login";
    AccountDataAnalysisEventKey["USER_INFO"] = "user_info";
    AccountDataAnalysisEventKey["JOB_TITLE"] = "job_title";
    AccountDataAnalysisEventKey["PERMISSIONS"] = "permissions";
    AccountDataAnalysisEventKey["USER_ID"] = "user_id";
    AccountDataAnalysisEventKey["JOIN_DATE"] = "join_date";
    AccountDataAnalysisEventKey["CREATED_DATE"] = "created_date";
    AccountDataAnalysisEventKey["LOGIN_CNT"] = "login_cnt";
    AccountDataAnalysisEventKey["LOGIN_ALL_CNT"] = "login_all_cnt";
    AccountDataAnalysisEventKey["EUREKA_LOGIN_CNT"] = "eureka_login_cnt";
    AccountDataAnalysisEventKey["EUREKA_LOGIN_DAYS"] = "eureka_login_days";
    // RD
    AccountDataAnalysisEventKey["EUREKA_RD_TECHNICAL_QA"] = "technical_qa";
    AccountDataAnalysisEventKey["EUREKA_RD_FIND_SOLUTION"] = "find_solution";
    AccountDataAnalysisEventKey["EUREKA_RD_QUICK_RESEARCH"] = "quick_research";
    AccountDataAnalysisEventKey["EUREKA_RD_EVALUATE_FEASIBILITY"] = "evaluate_feasibility";
    AccountDataAnalysisEventKey["EUREKA_RD_FEASIBILITY_ANALYSIS_ASSISTANT"] = "feasibility_analysis_assistant";
    AccountDataAnalysisEventKey["EUREKA_RD_HOMEPAGE_SEARCH"] = "homepage_search";
    AccountDataAnalysisEventKey["EUREKA_RD_PATENT_SEARCH"] = "rd_patent_search";
    AccountDataAnalysisEventKey["EUREKA_RD_LITERATURE_SEARCH"] = "rd_paper_search";
    AccountDataAnalysisEventKey["EUREKA_RD_IDEA_VALIDATION"] = "rd_novelty_check";
    AccountDataAnalysisEventKey["EUREKA_RD_INVENTION_DISCLOSURE"] = "rd_ai_disclosure";
    // IP
    AccountDataAnalysisEventKey["EUREKA_IP_NOVELTY_SEARCH"] = "novelty_search";
    AccountDataAnalysisEventKey["EUREKA_IP_NOVELTY_SEARCH_SUCCESS"] = "novelty_search_success";
    AccountDataAnalysisEventKey["EUREKA_IP_PATENT_DRAFTING_CN"] = "specification_cn";
    AccountDataAnalysisEventKey["EUREKA_IP_PATENT_DRAFTING_US"] = "specification_us";
    AccountDataAnalysisEventKey["EUREKA_IP_PATENT_DRAFTING_EU"] = "specification_eu";
    AccountDataAnalysisEventKey["EUREKA_IP_PATENT_TRANSLATION"] = "patent_translation";
    AccountDataAnalysisEventKey["EUREKA_IP_DESIGN_FTO_SEARCH"] = "design_fto_search";
    AccountDataAnalysisEventKey["EUREKA_IP_DESIGN_FTO_SEARCH_SUCCESS"] = "design_fto_search_success";
    AccountDataAnalysisEventKey["EUREKA_IP_FTO_SEARCH"] = "fto_search";
    AccountDataAnalysisEventKey["EUREKA_IP_FTO_SEARCH_SUCCESS"] = "fto_search_success";
    AccountDataAnalysisEventKey["EUREKA_IP_INVENTION_DISCLOSURE_SUCCESS"] = "invention_disclosure_success";
    AccountDataAnalysisEventKey["EUREKA_IP_PATENT_DRAFT_SUCCESS"] = "patent_draft_success";
    AccountDataAnalysisEventKey["EUREKA_IP_PROSECUTION_SUCCESS"] = "prosecution_success";
    // Materials
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_MATERIAL_PERFORMANCE_ANALYSIS"] = "material_performance_analysis";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_ALLOY_COMPOSITION_ANALYSIS"] = "alloy_composition_analysis";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_MULTI_D_SEARCH"] = "multi_d_search";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_SUBSTANCE_INQUIRY"] = "substance_inquiry";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_STRUCTURE_SEARCH"] = "structure_search";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_MATERIAL_SYNTHESIS_PROCESS"] = "material_synthesis_process";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_MATERIAL_PROFILE_SEARCH"] = "material_profile_search";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_COMPOSITION_SEARCH"] = "composition_search";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_SMART_SEARCH_PATENT"] = "ms_patent_search";
    AccountDataAnalysisEventKey["EUREKA_MATERIALS_SMART_SEARCH_LITERATURE"] = "ms_paper_search";
    // 专利详情查看
    AccountDataAnalysisEventKey["EUREKA_PATENT_VIEW"] = "patent_view";
    // 文献详情查看
    AccountDataAnalysisEventKey["EUREKA_PAPER_VIEW"] = "paper_view";
})(AccountDataAnalysisEventKey || (AccountDataAnalysisEventKey = {}));
/*
 *  数据分析视图类型
 */
export var AccountDataAnalysisViewType;
(function (AccountDataAnalysisViewType) {
    AccountDataAnalysisViewType["Chart"] = "chart";
    AccountDataAnalysisViewType["Table"] = "table";
})(AccountDataAnalysisViewType || (AccountDataAnalysisViewType = {}));
export var AccountDataAnalysisUserSummaryKey;
(function (AccountDataAnalysisUserSummaryKey) {
    AccountDataAnalysisUserSummaryKey["LOGIN_COUNT"] = "login_count";
    AccountDataAnalysisUserSummaryKey["LOGIN_DAYS"] = "login_days";
})(AccountDataAnalysisUserSummaryKey || (AccountDataAnalysisUserSummaryKey = {}));
